import { MessageSquare, Tag, X } from 'lucide-react';

import { AnnotateOptionBuilderParams } from '@/sections/asset/types';
import type { DropdownOption } from '@/types/dropdown.types';

export const getAssetAnnotateOptions = ({
  onCommentClick,
  onTagClick,
  onRemoveTagClick,
}: AnnotateOptionBuilderParams): DropdownOption[] => {
  return [
    {
      label: 'Add Note',
      icon: <MessageSquare className="size-4" />,
      onClick: onCommentClick,
    },
    {
      label: 'Add Tag',
      icon: <Tag className="size-4" />,
      onClick: onTagClick,
    },
    {
      label: 'Remove Tag',
      icon: <X className="size-4" />,
      onClick: onRemoveTagClick,
    },
  ];
};
